import { useLanguageStore } from '../lib/languageStore';
import { RosterViolations } from '../components/Messages/RosterViolations';
import { AlertTriangle } from 'lucide-react';

export function RosterValidation() {
  const { language } = useLanguageStore();

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="d-flex align-items-center mb-4">
            <AlertTriangle className="text-warning me-3" size={32} />
            <div>
              <h2 className="mb-1">
                {language === 'fr' ? 'Validation des alignements' : 'Roster Validation'}
              </h2>
              <p className="text-muted mb-0">
                {language === 'fr'
                  ? 'Vérifiez la conformité des alignements de tous les DG de la ligue'
                  : 'Check compliance of all GMs rosters in the league'}
              </p>
            </div>
          </div>

          <div className="card border-0 shadow-sm">
            <div className="card-body p-4">
              <RosterViolations language={language} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
